/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceChallengeZoneBingoCell
 */
export interface SurfaceChallengeZoneBingoCell {
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneBingoCell
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneBingoCell
     */
    state: SurfaceChallengeZoneBingoCellStateEnum;
}


/**
 * @export
 */
export const SurfaceChallengeZoneBingoCellStateEnum = {
    unchecked: 'unchecked',
    done: 'done',
    free: 'free'
} as const;
export type SurfaceChallengeZoneBingoCellStateEnum = typeof SurfaceChallengeZoneBingoCellStateEnum[keyof typeof SurfaceChallengeZoneBingoCellStateEnum];


/**
 * Check if a given object implements the SurfaceChallengeZoneBingoCell interface.
 */
export function instanceOfSurfaceChallengeZoneBingoCell(value: object): value is SurfaceChallengeZoneBingoCell {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function SurfaceChallengeZoneBingoCellFromJSON(json: any): SurfaceChallengeZoneBingoCell {
    return SurfaceChallengeZoneBingoCellFromJSONTyped(json, false);
}

export function SurfaceChallengeZoneBingoCellFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceChallengeZoneBingoCell {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'state': json['state'],
    };
}

export function SurfaceChallengeZoneBingoCellToJSON(json: any): SurfaceChallengeZoneBingoCell {
    return SurfaceChallengeZoneBingoCellToJSONTyped(json, false);
}

export function SurfaceChallengeZoneBingoCellToJSONTyped(value?: SurfaceChallengeZoneBingoCell | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'state': value['state'],
    };
}

